import React, { useEffect, useState } from 'react';
import { TextField, Typography, Snackbar } from '@material-ui/core';
import CloseImage from '../../assets/ic_close.png';
import api from '../api';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CustomTextField from '../components/customTextField';
import NumberFormat from 'react-number-format';
import IcDelete from '../../assets/ic_delete.png';

function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            thousandSeparator
            isNumericString
            prefix="Rp. "
        />
    );
}

export default function AddTagihanResep(props) {
    const [item, setItem] = useState("")
    const [pemakaian, setPemakaian] = useState("")
    const [satuanObat, setSatuanObat] = useState("")
    const [qty, setQTY] = useState("")
    const [amount, setAmount] = useState("")
    const [totalAmount, setTotalAmount] = useState("")
    const [racikan] = useState([
        { id: 0, name: 'Tidak' },
        { id: 1, name: 'Ya' }
    ])
    const [pickRacikan, setPickRacikan] = useState(null)
    const [medType] = useState([
        { id: 1, name: 'Obat Luar' },
        { id: 2, name: 'Obat Dalam' }
    ])
    const [pickMedType, setPickMedType] = useState(null)
    const [isiRacikan, setIsiRacikan] = useState("")
    const [itemRacikanLength, setItemRacikanLength] = React.useState([]);

    const [errorItem, setErrorItem] = React.useState(false);
    const [texterrorItem, setTextErrorItem] = React.useState(null);
    const [errorPemakaian, setErrorPemakaian] = React.useState(false);
    const [texterrorPemakaian, setTextErrorPemakaian] = React.useState(null);
    const [errorSatuanObat, setErrorSatuanObat] = React.useState(false);
    const [texterrorSatuanObat, setTextErrorSatuanObat] = React.useState(null);
    const [errorQTY, setErrorQTY] = React.useState(false);
    const [texterrorQTY, setTextErrorQTY] = React.useState(null);
    const [errorAmount, setErrorAmount] = React.useState(false);
    const [texterrorAmount, setTextErrorAmount] = React.useState(null);
    const [errorRacikan, setErrorRacikan] = React.useState(false);
    const [texterrorRacikan, setTextErrorRacikan] = React.useState(null);
    const [errorMedType, setErrorMedType] = React.useState(false);
    const [texterrorMedType, setTextErrorMedType] = React.useState(null);

    const forceUpdate = React.useReducer(bool => !bool)[1];

    const handleSave = () => {
        if (item === "") {
            setErrorItem(true)
            setTextErrorItem("Nama Obat wajib diisi")
        } else if (qty === "") {
            setErrorQTY(true)
            setTextErrorQTY("QTY wajib diisi")
        } else if (pemakaian === "") {
            setErrorPemakaian(true)
            setTextErrorPemakaian("Cara Pemakaian wajib diisi")
        } else if (satuanObat === "") {
            setErrorSatuanObat(true)
            setTextErrorSatuanObat("Satuan Obat wajib diisi")
        } else if (amount === "") {
            setErrorAmount(true)
            setTextErrorAmount("Amount wajib diisi")
        } else if (pickRacikan === null) {
            setErrorRacikan(true)
            setTextErrorRacikan("Keterangan Racikan wajib diisi")
        } else if (pickMedType === null) {
            setErrorMedType(true)
            setTextErrorMedType("Jenis Obat wajib diisi")
        } else {
            let payload = {
                item: item,
                qty: qty,
                pemakaian: pemakaian,
                pickRacikan: pickRacikan,
                amount: amount,
                totalAmount: totalAmount,
                satuanObat: satuanObat,
                pickMedType: pickMedType,
            }
            let tagihan = {
                pickType: { id: 2, name: 'Obat-obatan' },
                keterangan: item,
                qty: qty,
                amount: amount,
                keteranganTambahan: pemakaian,
                isMix: pickRacikan,
                dataRacikan: itemRacikanLength,
                satuanObat: satuanObat,
                pickMedType: pickMedType,
                totalAmount: totalAmount,
            }
            console.log(payload);
            props.onSubmit(payload)
            props.onSubmitPayment(tagihan)

        }
    }

    const handleTambah = () => {
        itemRacikanLength.push({
            itemRacikan: null,
        })
        forceUpdate()
    }

    const handleHapus = (index) => {
        itemRacikanLength.splice(index, 1)
        forceUpdate()
    }

    const handleJamReservasi = (val, index) => {
        itemRacikanLength[index].itemRacikan = val
        forceUpdate()
    }

    useEffect(() => {
    }, [])


    return (
        <div className="App app-popup-show">
            <div className="popup-content background-white" style={{ borderRadius: 8, backgroundColor: 'white' }}>
                <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                    <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                        <div className="popup-title">
                            <span style={{ color: 'black', fontSize: 18, }}>Detail Tagihan Resep</span>
                        </div>
                    </div>
                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                        <button
                            type="button"
                            className="btn btn-circle btn-white"
                            onClick={() => props.onClose()}
                        >
                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                        </button>
                    </div>
                </div>
                <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: 20, paddingRight: 50, paddingLeft: 50 }}>
                    <div className="column-1">
                        <TextField
                            required={true}
                            label={"Nama Obat"}
                            style={{ width: '90%' }}
                            error={errorItem}
                            helperText={texterrorItem}
                            onChange={(e) => {
                                setItem(e.target.value)
                                setErrorItem(false)
                                setTextErrorItem(null)
                            }}
                            InputLabelProps={{
                                style: {
                                    fontSize: 14,
                                    color: '#7e8085',
                                    fontFamily: 'Poppins',
                                }
                            }}
                        />
                    </div>
                    <div className="column-2" style={{ display: 'flex' }}>
                        <TextField
                            required={true}
                            label={"QTY"}
                            error={errorQTY}
                            helperText={texterrorQTY}
                            style={{ width: '90%', textAlign: 'left' }}
                            onChange={(e) => {
                                setQTY(e.target.value)
                                setErrorQTY(false)
                                setTextErrorQTY(null)
                            }}
                            InputLabelProps={{
                                style: {
                                    fontSize: 14,
                                    color: '#7e8085',
                                    fontFamily: 'Poppins',
                                }
                            }}
                        />
                    </div>
                    <div className="column-1">
                        <TextField
                            required={true}
                            label={"Cara Pemakaian"}
                            style={{ width: '90%' }}
                            error={errorPemakaian}
                            helperText={texterrorPemakaian}
                            onChange={(e) => {
                                setPemakaian(e.target.value)
                                setErrorPemakaian(false)
                                setTextErrorPemakaian(null)
                            }}
                            InputLabelProps={{
                                style: {
                                    fontSize: 14,
                                    color: '#7e8085',
                                    fontFamily: 'Poppins',
                                }
                            }}
                        />
                    </div>
                    <div className="column-2" style={{ display: 'flex' }}>
                        <TextField
                            required={true}
                            label={"Satuan Obat"}
                            style={{ width: '90%', textAlign: 'left' }}
                            error={errorSatuanObat}
                            helperText={texterrorSatuanObat}
                            onChange={(e) => {
                                setSatuanObat(e.target.value)
                                setErrorSatuanObat(false)
                                setTextErrorSatuanObat(null)
                            }}
                            InputLabelProps={{
                                style: {
                                    fontSize: 14,
                                    color: '#7e8085',
                                    fontFamily: 'Poppins',
                                }
                            }}
                        />
                    </div>
                    <div className="column-1">
                        <TextField
                            required={true}
                            label={"Amount"}
                            style={{ width: '90%' }}
                            error={errorAmount}
                            helperText={texterrorAmount}
                            onChange={(e) => {
                                setAmount(e.target.value)
                                setTotalAmount(Number(e.target.value) * Number(qty))
                                setErrorAmount(false)
                                setTextErrorAmount(null)
                                forceUpdate()
                            }}
                            // onBlur={(e) => {
                            //     setTotalAmount(Number(e.target.value) * Number(qty))
                            //     console.log(Number(e.target.value) * Number(qty));
                            //     forceUpdate()
                            // } }
                            InputLabelProps={{
                                style: {
                                    fontSize: 14,
                                    color: '#7e8085',
                                    fontFamily: 'Poppins',
                                }
                            }}
                            InputProps={{
                                inputComponent: NumberFormatCustom,
                            }}
                        />
                    </div>
                    <div className="column-2" style={{ textAlign: 'left' }}>
                        <TextField
                            disabled
                            label={"Total Amount"}
                            style={{ width: '90%' }}
                            value={totalAmount}
                            InputLabelProps={{
                                style: {
                                    fontSize: 14,
                                    color: '#7e8085',
                                    fontFamily: 'Poppins',
                                }
                            }}
                            InputProps={{
                                inputComponent: NumberFormatCustom,
                            }}
                        />
                    </div>
                    <div className="column-1">
                        <Autocomplete
                            options={racikan}
                            getOptionLabel={(option) => option.name}
                            onChange={(event, newInputValue) => {
                                setPickRacikan(newInputValue)
                                setErrorRacikan(false)
                                setTextErrorRacikan(null)
                                forceUpdate()
                            }}
                            style={{ width: '90%', marginLeft: 15 }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    required={true}
                                    error={errorRacikan}
                                    helperText={texterrorRacikan}
                                    InputProps={{ ...params.InputProps, style: { fontSize: 14 } }}
                                    InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                    label="Keterangan Racikan"
                                />
                            }
                            value={pickRacikan}
                        />
                    </div>

                    <div className="column-2">
                        <Autocomplete
                            options={medType}
                            getOptionLabel={(option) => option.name}
                            onChange={(event, newInputValue) => {
                                setPickMedType(newInputValue)
                                setErrorMedType(false)
                                setTextErrorMedType(null)
                                forceUpdate()
                            }}
                            style={{ width: '90%' }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    required={true}
                                    error={errorMedType}
                                    helperText={texterrorMedType}
                                    InputProps={{ ...params.InputProps, style: { fontSize: 14 } }}
                                    InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                    label="Jenis Obat"
                                />
                            }
                            value={pickMedType}
                        />
                    </div>

                    {/* {pickRacikan ?
                        pickRacikan.id === 1 ?
                            <div className="column-2" style={{ display: 'flex' }}>
                                <TextField
                                    label={"Item Racikan Obat"}
                                    style={{ width: '90%', textAlign: 'left' }}
                                    onChange={(e) => {
                                        setItemRacikan(e.target.value)
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            fontSize: 14,
                                            color: '#7e8085',
                                            fontFamily: 'Poppins',
                                        }
                                    }}
                                />
                            </div>
                            :
                            null
                        :
                        null
                    } */}

                </div>
                {pickRacikan &&
                    pickRacikan.id === 1 && (
                        <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: '0px 50px 20px' }}>
                            <div className="column-1" style={{ marginTop: 10, textAlign: 'left' }}>
                                <button style={{ outline: 'none', backgroundColor: 'transparent', borderColor: 'transparent', cursor: 'pointer', marginTop: 10, padding: 0 }}
                                    onClick={() => handleTambah()}
                                >
                                    <Typography style={{ fontWeight: '500', color: '#0066ff' }}>+ Tambah Item Racikan</Typography>
                                </button>
                            </div>

                            {itemRacikanLength && itemRacikanLength.map((item, index) => (
                                <div className={index % 2 === 0 ? "column-1" : "column-2"}>
                                    <div style={{ display: 'flex', marginTop: index === 0 || index === 1 ? 0 : 10 }}>
                                        <div className="">
                                            <TextField
                                                label={"Item Racikan Obat"}
                                                style={{ width: '90%', textAlign: 'left' }}
                                                onChange={(e) => {
                                                    itemRacikanLength[index].itemRacikan = e.target.value
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 14,
                                                        color: '#7e8085',
                                                        fontFamily: 'Poppins',
                                                    }
                                                }}
                                            />
                                        </div>
                                        <button
                                            type="button"
                                            className="btn btn-circle btn-white"
                                            style={{ borderColor: 'transparent', outline: 'none', marginTop: 10, padding: 5 }}
                                            onClick={() => handleHapus(index)}
                                        >
                                            <div style={{ width: 24, height: 24, backgroundColor: '#278863', borderRadius: 15 }}>
                                                <img src={IcDelete} style={{ width: 12, height: 12 }} />
                                            </div>
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                    <div className="column-1" style={{ alignSelf: 'center' }}>
                    </div>
                    <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <div onClick={() => props.onClose()} style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                            <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                        </div>
                        <div onClick={(e) => handleSave()} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                            <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Simpan</Typography>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}